import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'

import { api } from 'src/Services/api'
import { APP } from 'src/Configs/App'

import { NameSpace } from '../types'

interface PaymentEvent {
  campaignId: number | string
  transaction: { price: number; start_date: string | Date | undefined }
  url: string
}

interface PaymentPlatformEvent {
  campaignId: number | string
  transaction: { price: number; start_date: string | null }
  url: string
  platform: string
}

interface PaymentInfoEvent {
  campaignID: number | string
  url: string
}

interface CreateTiktokCampaignEvent {
  campaignID: number | string
  url: string
  token?: string
}

interface GoogleAnalyticsResponse {
  errors: string[]
}

export const sendPaymentStartEvent = createAsyncThunk<void, PaymentEvent>(
  `${NameSpace.GoogleAnalytics}/sendPaymentStartEvent`,
  async ({ campaignId, transaction, url }, { rejectWithValue }) => {
    try {
      const { data } = await api.post<void>(
        `${APP.SERVER}/campaign/payment-start-event/${campaignId}`,
        {
          transaction,
          url,
        },
      )
      return data
    } catch (error) {
      const { response } = error as AxiosError<{ message: string }>
      return rejectWithValue({
        message: response?.data.message,
        status: response?.status,
      })
    }
  },
)

export const sendPaymentStartPlatformEvent = createAsyncThunk<
  GoogleAnalyticsResponse,
  PaymentPlatformEvent
>(
  `${NameSpace.GoogleAnalytics}/sendPaymentStartPlatformEvent`,
  async ({ campaignId, platform, transaction, url }, { rejectWithValue }) => {
    try {
      const { data } = await api.post<GoogleAnalyticsResponse>(
        `${APP.SERVER}/campaign/payment-start-event/${platform}/${campaignId}`,
        {
          transaction,
          url,
        },
      )
      return data
    } catch (error) {
      const { response } = error as AxiosError<{ message: string }>
      return rejectWithValue({
        message: response?.data.message,
        status: response?.status,
      })
    }
  },
)

export const sendPaymentInfoEvent = createAsyncThunk<void, PaymentInfoEvent>(
  `${NameSpace.GoogleAnalytics}/sendPaymentInfoEvent`,
  async ({ campaignID, url }, { rejectWithValue }) => {
    try {
      const { data } = await api.post<void>(
        `${APP.SERVER}/campaign/payment-info/${campaignID}`,
        { url },
      )
      return data
    } catch (error) {
      const { response } = error as AxiosError<{ message: string }>
      return rejectWithValue({
        message: response?.data.message,
        status: response?.status,
      })
    }
  },
)

export const createTiktokCampaignEvent = createAsyncThunk<
  GoogleAnalyticsResponse,
  CreateTiktokCampaignEvent
>(
  `${NameSpace.GoogleAnalytics}/createTiktokCampaignEvent`,
  async ({ campaignID, url, token }, { rejectWithValue }) => {
    try {
      const { data } = await api.post<GoogleAnalyticsResponse>(
        `${APP.SERVER}/campaign/create-tiktok-campaign-event/${campaignID}`,
        { url },
        {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        },
      )
      return data
    } catch (error) {
      const { response } = error as AxiosError<{ message: string }>
      return rejectWithValue({
        message: response?.data.message,
        status: response?.status,
      })
    }
  },
)
